module.exports = __webpack_public_path__ + "img/primary_9x2_z18.4d51d02d.svg";